import iconifyIconOffline from "./src/iconifyIconOffline";
import iconifyIconOnline from "./src/iconifyIconOnline";
import fontIcon from "./src/iconfont";
import iconSelect from "./src/Select.vue";

/** 本地图标组件 */
const IconifyIconOffline = iconifyIconOffline;
/** 在线图标组件 */
const IconifyIconOnline = iconifyIconOnline;
/** `iconfont`组件 */
const FontIcon = fontIcon;
/** `IconSelect`图标选择器组件 */
const IconSelect = iconSelect;

export { IconifyIconOffline, IconifyIconOnline, FontIcon, IconSelect };
